import * as React from 'react';

function SvgCeurLogo(props) {
  return (
    <svg
      width={100}
      height={100}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="50" cy="50" r="50" fill="#5AAD91" />
      <path
        d="M44.9037 87.6865L49.6388 88.0335L49.2741 93.0101L44.539 92.6631L44.9037 87.6865Z"
        fill="#FDFAF3"
      />
      <path
        d="M56.2079 2.79591L65.6199 12.0463L52.8132 15.2313L56.2079 2.79591Z"
        fill="#F8AEA5"
        stroke="#FDFAF3"
        strokeWidth="1.5"
      />
      <path
        d="M43.2424 96.2593L33.8304 87.009L46.6371 83.824L43.2424 96.2593Z"
        fill="#F8AEA5"
        stroke="#FDFAF3"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.5 6C51.8397 6 53.1652 6.06056 54.4741 6.1791L53.3211 11.1018C52.3895 11.0343 51.4488 11 50.5 11C29.237 11 12 28.237 12 49.5C12 63.9787 19.9924 76.5907 31.8059 83.1648L30.6255 88.2047C16.5961 80.9861 7 66.3637 7 49.5C7 25.4756 26.4756 6 50.5 6ZM46.1161 92.7818C47.5578 92.9261 49.0203 93 50.5 93C74.5244 93 94 73.5244 94 49.5C94 32.1648 83.8599 17.198 69.1875 10.2074L68.0166 15.2065C80.4735 21.582 89 34.5453 89 49.5C89 70.763 71.763 88 50.5 88C49.4113 88 48.3332 87.9548 47.2674 87.8662L46.1161 92.7818Z"
        fill="#FDFAF3"
      />
      <path
        d="M65.5 33V23.5C64.8333 22.6667 61.9 21 55.5 21C37.5 21 30.5 36.5 30.5 49C30.5 80.5 51.5 78 55.5 78C58.7 78 63.5 76.3333 65.5 75.5V66C64.5 67.3333 61.1 70 55.5 70C48.5 70 42 64.5 42 49C42 33.5 51.5 29.5 55.5 29.5C58.7 29.5 63.5 31.8333 65.5 33Z"
        fill="#FDFAF3"
      />
      <rect x="28" y="39.5" width="33" height="8" fill="#FDFAF3" />
      <rect x="28" y="52.5" width="33" height="8" fill="#FDFAF3" />
    </svg>
  );
}

export default SvgCeurLogo;
